import {
  ArrowLeftOutlined,
  ArrowRightOutlined
} from "@ant-design/icons";
import {
  FormDrawer
} from "Components";
import { withFormik } from "formik";
import useAuthHook from "hooks/useAuthHook";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useGetManageOffersMutation,
  useUpdateManageOffersMutation,
} from "services/auth";
import { Button } from "shared/components/Button";
import routes, { appRoute } from "shared/constants/routes";
import { useTranslation } from "../../../contexts/TranslationContext";
import { manageOffersSchema } from "../CreateRequest/schemas";
const ManageOffers = withFormik({
})((props) => {
  const { translate, language } = useTranslation();
  const navigate = useNavigate();
  const isRtl = language.dir === "rtl";
  const { getUser } = useAuthHook();
  const [updateManageOffers] = useUpdateManageOffersMutation();
  const [getManageOffers] = useGetManageOffersMutation();

  const navigateBack = () => {
    navigate(appRoute(routes.SETTING_ROOT));
  };
  const handleSave = async () => {
    try {
      const user = getUser();
      if (!user) return;
      const requestBody = {
        id: String(user.IDB_USR_ID),
        offers_enabled: props.values.offers_enabled ? 1 : 0, // Convert boolean to number
      }
      console.log("Save button clicked");
      await updateManageOffers(requestBody).unwrap();
      toast.success("Notifications updated successfully.");
      setTimeout(() => {
        navigateBack()
      }, 1000)
    } catch (error) {
      console.error("Error updating managing offers:", error);
      toast.error("Failed to update managing offers.");
    }
  }
  useEffect(() => {
    const fetchData = async () => {
      const user = getUser();
      if (!user) return;

      const res = await getManageOffers({
        id: Number(user?.IDB_USR_ID),
      }).unwrap();
      if (res?.result) {
        console.log(res?.result.OFFERS_ENABLED, "manageOffersData");
        const offersEnabled = Boolean(res?.result.OFFERS_ENABLED); // Convert to boolean
        props.setFieldValue("offers_enabled", offersEnabled);
      }
    }

    fetchData()
  }, []);

  return (
    <>
      <div className="rounded-xl min-h-16 mb-4 px-4 py-8 bg-white items-center shadow">
        <div className="gap-3 flex items-center">
          <div
            className="bg-[#F3EDDD] rounded-lg hover:bg-gray-100 transition duration-300 flex items-center justify-center w-10 h-10"
            onClick={navigateBack}
          >
            {isRtl ? (
              <ArrowRightOutlined className="text-black text-lg font-extrabold" />
            ) : (
              <ArrowLeftOutlined className="text-black text-lg font-extrabold" />
            )}
          </div>
          <div className="text-[#161616] text-[22px] font-normal font-sans hidden md:block">
            {translate("SETTINGS.BACK")}
          </div>
        </div>
        <div className="text-black text-2xl font-semibold mt-3 mb-3">
          {translate("SETTINGS.MANAGE_OFFERS")}
        </div>

        <div className="mb-4">
          <FormDrawer
            schema={{
              fields: manageOffersSchema,
            }}
            values={props.values}
            onChange={props.handleChange} />
        </div>
        {/* Add horizontal space only on mobile */}
        <div className="mt-80 md:hidden" />

        <div className="flex items-center justify-end gap-2">
          <Button
            onClick={navigateBack}
            color="primary"
            mode="outline"
            className="rounded-xl h-12 w-32"
          >
            {translate("CREATE_REQUEST.CANCEL")}
          </Button>
          <Button
            onClick={handleSave}
            color="primary"
            className="rounded-xl h-12 w-64"
          >
            {translate("SETTINGS.SAVE")}
          </Button>
        </div>

      </div>
      {/* Add horizontal space only on md screen */}
      <div className="hidden md:block">
        <div className="mt-56" />
      </div>
      {/* put the text all rights Reserved in the center */}
      <hr className="hidden md:block" />
      <p className="text-center text-gray-500 text-sm mt-4">
        {translate("SETTINGS.ALL_RIGHTS_RESERVED")}
      </p>
    </>
  );
});

export default ManageOffers;
